export default function () {
    return (
        <svg width="24" height="38" viewBox="0 0 24 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="1.02672" y1="36.9585" x2="23.0267" y2="0.95853" stroke="#FF8000" strokeWidth="2" />
        </svg>
    );
}
